import Vue from 'vue'
import Vuex from 'vuex'

import { camelize } from '@utils/string'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
const read = require.context('./modules', true, /\.js$/)
const injectingModules = {}

read.keys().forEach((key) => {
  const storeModule = read(key).default
  const storeName = camelize(key.replace(/^.*[\\\/]/, '').replace('.js', ''))

  injectingModules[storeName] = storeModule
})

export default new Vuex.Store({
  strict: debug,
  modules: injectingModules
})
